module.exports = __webpack_public_path__ + "assets/img/Compact.27661abc.svg";